import { render, staticRenderFns } from "./ParametrosDefaultCampos.vue?vue&type=template&id=2b4b7bee&"
import script from "./ParametrosDefaultCampos.vue?vue&type=script&lang=js&"
export * from "./ParametrosDefaultCampos.vue?vue&type=script&lang=js&"
import style0 from "./ParametrosDefaultCampos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VDatePicker,VMenu,VTextField,VTextarea})
